module.exports = __webpack_public_path__ + "img/whats-new-12_jp.08bdcba.jpg";